import { lazy } from 'react';
import urlPath from 'src/constants/urlPath';
import MainLayoutV2 from 'src/layouts/v2/MainLayout';
import TicketLayout from 'src/layouts/v2/TicketLayout';
import type { RouteGroup } from './types';

// Lazy load V2 HR Confirm components
const ExpenseTrackingRequestTicketHrConfirm = lazy(() => import('src/pages/v2/HrConfirm/ExpenseTrackingRequestTicket'));
const LeaveTicketHrConfirm = lazy(() => import('src/pages/v2/HrConfirm/LeaveTicket'));
const BusinessTripHrConfirm = lazy(() => import('src/pages/v2/HrConfirm/BusinessTripTicket'));
const OvertimeHrConfirm = lazy(() => import('src/pages/v2/HrConfirm/OvertimeTicket'));
const TransportationHrConfirm = lazy(() => import('src/pages/v2/HrConfirm/TransportationTicket'));
const ResignationTickettHrConfirm = lazy(() => import('src/pages/v2/HrConfirm/ResignationTicket'));
const AdditionalWorkingTimeTicketHrConfirm = lazy(() => import('src/pages/v2/HrConfirm/AdditionalWorkingTimeTicket'));

export const hrConfirmRoutes: RouteGroup = [
  // HR Confirm Routes
  {
    path: urlPath.hrConfirm.location,
    Layout: MainLayoutV2,
    redirect: urlPath.hrConfirmLeaveTicket.location,
    hasSidebar: false,
    hasSubHeader: false,
    isDisableFooter: true
  },

  // Expense Tracking Request HR Confirm
  {
    path: urlPath.hrConfirmExpenseTrackingRequestTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: ExpenseTrackingRequestTicketHrConfirm,
    hasSidebar: true
  },
  {
    path: `${urlPath.hrConfirmExpenseTrackingRequestTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: ExpenseTrackingRequestTicketHrConfirm,
    hasSidebar: true
  },

  // Leave Ticket HR Confirm
  {
    path: urlPath.hrConfirmLeaveTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: LeaveTicketHrConfirm,
    hasSidebar: true
  },
  {
    path: `${urlPath.hrConfirmLeaveTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: LeaveTicketHrConfirm,
    hasSidebar: true
  },

  // Business Trip HR Confirm
  {
    path: urlPath.hrConfirmBusinessTripTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: BusinessTripHrConfirm,
    hasSidebar: true
  },
  {
    path: `${urlPath.hrConfirmBusinessTripTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: BusinessTripHrConfirm,
    hasSidebar: true
  },

  // Overtime HR Confirm
  {
    path: urlPath.hrConfirmOvertimeTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: OvertimeHrConfirm,
    hasSidebar: true
  },
  {
    path: `${urlPath.hrConfirmOvertimeTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: OvertimeHrConfirm,
    hasSidebar: true
  },

  // Transportation HR Confirm
  {
    path: urlPath.hrConfirmTransportationTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TransportationHrConfirm,
    hasSidebar: true
  },
  {
    path: `${urlPath.hrConfirmTransportationTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: TransportationHrConfirm,
    hasSidebar: true
  },

  // Resignation HR Confirm
  {
    path: urlPath.hrConfirmResignationTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: ResignationTickettHrConfirm,
    hasSidebar: true
  },
  {
    path: `${urlPath.hrConfirmResignationTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: ResignationTickettHrConfirm,
    hasSidebar: true
  },

  // Additional Working Time HR Confirm
  {
    path: urlPath.hrConfirmAdditionalWorkingTimeTicket.location,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AdditionalWorkingTimeTicketHrConfirm,
    hasSidebar: true
  },
  {
    path: `${urlPath.hrConfirmAdditionalWorkingTimeTicket.location}/:id`,
    Layout: MainLayoutV2,
    SubLayout: TicketLayout,
    Component: AdditionalWorkingTimeTicketHrConfirm,
    hasSidebar: true
  }
];
